export default __webpack_public_path__ + "static/media/settings_shipping_img.f27bcc7f.svg";